import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import { IconButton, Typography } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import { useEffect, useState } from 'react';
import { FaEye } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import swal from 'sweetalert';
import { BarraOpciones } from '../../../Components/EvaluacionDesempeño/Barra/BarraOpciones';
import { EvaluacionDetalleModal, EvaluacionNotificacionModal } from '../../../Components/EvaluacionDesempeño/Modal';
import Loading from '../../../Components/Modals/Loading/Loader';
import { ProgressValueComponent } from '../../../Components/ProgressValue/ProgressValueComponent';
import { PermissionData } from '../../../context/Component/PermissionData';
import {
  fetchCambiarSuccess,
  fetchEvaluacionEliminar,
  fetchEvaluacionNotificacionesAll,
  fetchGenerarEvaluacionEmpleadoPDF,
  fetchGetReporteEvaluacionesPorGrupo,
  fetchListaEvaluacionesPagination,
  fetchListaEvaluacionesPaginationCount,
  fetchObtenerEstadoPeriodo,
  fetchReabrirEvaluacion,
  selectEstadoPeriodo,
  selectIsLoading,
  selectIsSuccess,
  selectListaEvaluacionesPagination,
  selectListaEvaluacionesPaginationCount,
  selectMessage,
} from '../../../redux/Evaluaciones/EvaluacionesSlice';

import { Encabezado } from '../../../Components/Encabezado/Encabezado';
import { fetchAreasOrganizacionales, selectAllAreasOrganizacionales } from '../../../redux/AreaOrganizacional/AreaOrganizacionalSlice';
import { fetchGetEmpleadosSupervisores, selectSupervisoresSelectList } from '../../../redux/Empleados/EmpleadosSlice';
import {
  calcGrupoOcupacionalCompetencias,
  calcGrupoOcupacionalCompetenciasComportamientos2024,
  calcTotalEvaluaciones2023,
} from '../functions/evaluacionesFunciones';

const defaultValuesFilter = {
  ano: 0,
  page: 0,
  rowsPerPage: 25,
  supervisor: false,
  nombreEmpleado: '',
  evaluadorId: 0,
  areaId: 0,
  porcentaje: {
    id: 0,
    label: 'Seleccionar Categoría',
    calificacionDesde: 0,
    calificacionHasta: 0,
  },
};

export const EvaluacionDesempeñoDetalle = ({ supervisor = false }) => {
  /* 

  * **************************************************************** *
  * *****************- ESTADOS DE UNA EVALUACION: -***************** *
  * **************************************************************** *
  *
  * 0: DISPONIBLE PARA EVALUAR.
  * 1: EVALUACION CERRADA INCLUYENDO EL PERIODO
  * 2: ACUERDOS DE DESEMPEÑOS DIGITADOS (APROBADO POR EL EVALUADOR)
  *
  * *************************************************************** *
  * *************************************************************** *
  */

  /*
   * ************************************ *
   * *****- ESTADOS DE UN PERIODO: -***** *
   * ************************************ *
   *
   * 0: PERIODO ABIERTO
   * 1: PERIODO CERRADO
   *
   * ************************************ *
   * ************************************ *
   */

  // * PERMISOS DEL USUARIO.
  const permisosState = PermissionData();

  // * PARAMETRO A TRAVES DE LA RUTA.
  const { ano = 0 } = useParams();

  // ? HOOK DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-SELECTOR
  const listaEvaluacionesPorAno = useSelector(selectListaEvaluacionesPagination);
  const listaEvaluacionesPorAnoCount = useSelector(selectListaEvaluacionesPaginationCount);
  const isLoading = useSelector(selectIsLoading);
  const estadoPeriodo = useSelector(selectEstadoPeriodo);
  const isSuccess = useSelector(selectIsSuccess);
  const isMessage = useSelector(selectMessage);
  const listAreaOrganizacionales = useSelector(selectAllAreasOrganizacionales);
  const supervisores = useSelector(selectSupervisoresSelectList);

  // ? HOOK NAVEGACION.
  const navigate = useNavigate();

  // ? HOOK-STATE PARA MODAL.
  const [open, setOpen] = useState(false);
  const [openN, setOpenN] = useState(false);
  const [tipoAccion, setTipoAccion] = useState(0);
  const [evaluado, setEvaluado] = useState({});

  // ? HOOK-STATE DE PAGINACION.
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [skipRow, setSkipRow] = useState(0);
  const [validationActionNotify, setValidationActionNotify] = useState(0);
  const [filtroState, setFiltroState] = useState(defaultValuesFilter);
  const [refreshListState, setRefreshListState] = useState(false);

  // ? HOOK-STATE EMPLEADO
  const [empleado, setEmpleado] = useState('');

  // ? HOOK-STATE DE LISTAS
  const [listaAreasState, setListaAreasState] = useState([]);
  const [supervisoresListState, setSupervisoresListState] = useState([]);

  // * FUNCION PARA ACTUALIZAR LA LISTA.
  const refreshList = () => {
    const filtro = {
      ...filtroState,
      anio: ano,
      index: skipRow,
      itemsPerPage: rowsPerPage,
      grupoV: supervisor,
      calificacionDesde: filtroState.porcentaje.calificacionDesde,
      calificacionHasta: filtroState.porcentaje.calificacionHasta,
    };

    dispatch(fetchListaEvaluacionesPagination(filtro));
    dispatch(fetchListaEvaluacionesPaginationCount(filtro));
  };

  useEffect(() => {
    dispatch(fetchAreasOrganizacionales());
    dispatch(fetchGetEmpleadosSupervisores());
  }, []);

  // ? HOOK-EFFECT
  useEffect(() => {
    dispatch(fetchObtenerEstadoPeriodo(ano));
    setFiltroState({ ...filtroState, ano, page, rowsPerPage, supervisor });
  }, [ano, page, rowsPerPage, supervisor, dispatch]);

  useEffect(() => {
    if (refreshListState) {
      refreshList();
      setRefreshListState(false);
    }
  }, [refreshListState]);

  useEffect(() => {
    if (filtroState) {
      refreshList();
    }
  }, [page, rowsPerPage, filtroState.ano, filtroState.evaluadorId, filtroState.areaId, filtroState.areaId, filtroState.porcentaje]);

  useEffect(() => {
    if (isSuccess === 'success' && isMessage.length > 0) {
      swal('Exitoso!', isMessage, 'success');
      dispatch(fetchCambiarSuccess());
    } else if (isSuccess === 'error' && isMessage.length > 0) {
      swal('Error', isMessage, 'error');
      dispatch(fetchCambiarSuccess());
    }
  }, [isSuccess]);

  useEffect(() => {
    setListaAreasState([{ id: 0, nombre: 'Seleccionar Área' }, ...listAreaOrganizacionales]);
    setSupervisoresListState([{ id: 0, nombreLabel: 'Seleccionar Evaluador' }, ...supervisores]);
  }, [listAreaOrganizacionales, supervisores]);

  // * FUNCION PARA CAMBIAR EL ESTADO.
  const openModalCrear = () => {
    setTipoAccion(0);
    setOpen(true);
  };

  // * FUNCIONES PARA GENERAR NOTIFICACIONES
  const generarNotificacionesEvaluacionesAll = () => {
    swal({
      title: 'Confirmación',
      text: 'Estás seguro/a que desea notificar a todos los evaluadores?',
      icon: 'warning',
      buttons: ['No', 'Si'],
    }).then((respuesta) => {
      if (respuesta) {
        dispatch(fetchEvaluacionNotificacionesAll(ano));
        refreshList();
      }
    });
  };

  // * FUNCIONES DE MODALS.
  const openModalEditar = (evaluado) => {
    setEvaluado(evaluado);
    setTipoAccion(1);
    setOpen(true);
  };

  const openModalNotificacion = (type) => {
    setValidationActionNotify(type);
    setOpenN(true);
  };

  // * FUNCION PARA NAVEGAR A OTRA PANTALLA.
  const openEvaluacionEmpleado = (hash) => {
    navigate(`/evaluaciones/desempeno/empleado/${hash}`, { state: { supervisor: supervisor ?? false } });
  };

  // * FUNCION PARA LA PAGINACION
  const handleChangePage = (event, newPage) => {
    setSkipRow(newPage * rowsPerPage);
    setPage(newPage);
  };

  // * FUNCION PARA CALCULAR VALORES SEGUN EL GRUPO OCUPACIONAL.
  const calcGrupoOcupacionalLogroMetas = (value, grupoOcupacional) => {
    return grupoOcupacional === 5 ? (value * 100) / 65 : (value * 100) / 55;
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setSkipRow(0);
  };

  // * FUNCION QUE ELIMINA UNA EVALUACION
  const deleteEvaluacion = (id) => {
    swal({
      title: 'Eliminar',
      text: 'Estás seguro/a de eliminar esta evaluación?',
      icon: 'warning',
      buttons: ['No', 'Si'],
    }).then((respuesta) => {
      if (respuesta) {
        dispatch(fetchEvaluacionEliminar(id));
        refreshList();
      }
    });
  };

  // * FUNCION PARA REABRIR UNA EVALUACION
  const openEvaluation = (evaluacionId) => {
    swal({
      title: 'Confirmación',
      text: 'Estás seguro/a que desea reabrir esta evaluación?',
      icon: 'warning',
      buttons: ['No', 'Si'],
    }).then((respuesta) => {
      if (respuesta) {
        dispatch(fetchReabrirEvaluacion(evaluacionId));
        refreshList();
      }
    });
  };

  // * FUNCION PARA GENERAR REPORTE PDF.
  const generateReportEvaluacion = (item) => {
    if (item.ano < 2023) {
      swal('Información', 'Reporte en desarrollo, favor de usar esta función a partir del período 2023.', 'warning');
    } else {
      dispatch(fetchGenerarEvaluacionEmpleadoPDF(item));
    }
  };

  // * OBTENER REPORTES POR GRUPO OCUPACIONAL EN UN .zip.
  const getReportPerGroup = (id) => dispatch(fetchGetReporteEvaluacionesPorGrupo(id));

  // * FUNCION PARA ACTUALIZAR FILTROS.
  const updateFilter = (name, value) => {
    if (name !== 'nombreEmpleado') {
      setPage(0);
      setSkipRow(0);
      setRowsPerPage(25);
    }

    setFiltroState({ ...filtroState, [name]: value });
  };

  // * FUNCION DE LIMPIAR FILTROS.
  const cleanfilter = () => {
    setFiltroState(defaultValuesFilter);
    setRefreshListState(true);
  };

  return (
    <Encabezado title={'Evaluaciones de desempeño'} ano={estadoPeriodo.ano}>
      <BarraOpciones
        supervisor={supervisor}
        openModalCrear={openModalCrear}
        openModalNotificacion={openModalNotificacion}
        updateFilter={updateFilter}
        filtroState={filtroState}
        estadoPeriodo={estadoPeriodo.estado}
        route={'/evaluaciones/desempeno'}
        getReportPerGroup={getReportPerGroup}
        refreshList={refreshList}
        listaAreasState={listaAreasState}
        supervisoresListState={supervisoresListState}
        cleanfilter={cleanfilter}
        setRefreshListState={setRefreshListState}
      />

      {listaEvaluacionesPorAno.length > 0 ? (
        listaEvaluacionesPorAno.map((item, index) => (
          <div className="card mb-2" key={index}>
            <div className="row g-0">
              <div className="col-2 text-center mt-3 mb-3">
                <p className="card-text fw-bold text-14">Evaluado</p>
                <p className="text-14">{item.empleado}</p>
              </div>

              <div className="col-2">
                <div className="text-center mt-3 mb-3">
                  <p className="card-text fw-bold text-14">Evaluador</p>
                  <p className="text-14">{item.evaluador}</p>
                </div>
              </div>

              <div className="col-2">
                <div className="text-center mt-3 mb-3">
                  <p className="card-text fw-bold text-14">Grupo ocupacional</p>
                  <p className="text-14">{item.grupoOcupacional}</p>
                </div>
              </div>

              <div className="col-3">
                <p>&nbsp;</p>
                <div className="text-center text-14 mt-3 mb-3 d-flex justify-content-center">
                  <ProgressValueComponent
                    value={calcGrupoOcupacionalLogroMetas(item.resultadoValor, item.grupoOcupacional)}
                    ponderacion={item.resultadoValor}
                  />

                  {estadoPeriodo.ano < 2023 && (
                    <>
                      <Typography color="#003876">+</Typography>
                      <ProgressValueComponent
                        value={Math.round(calcGrupoOcupacionalCompetencias(item.resultadoCompetenciaValor, item.grupoOcupacional))}
                      />
                      <Typography color="#003876">+</Typography>
                      <ProgressValueComponent value={(item.resultadoRedValor * 100) / 15} ponderacion={item.resultadoRedValor} />
                    </>
                  )}

                  <Typography color="#003876">{estadoPeriodo.ano < 2028 ? '=' : '+'}</Typography>
                  {estadoPeriodo.ano !== 2028 ? (
                    <ProgressValueComponent
                      value={estadoPeriodo.ano < 2023 ? item.totalEvaluacion : calcTotalEvaluaciones2023(item.totalEvaluacion, item.grupoOcupacional)}
                    />
                  ) : (
                    <>
                      <ProgressValueComponent
                        value={Math.round(
                          calcGrupoOcupacionalCompetenciasComportamientos2024(item.resultadoCompetenciasComportamientosMap, item.grupoOcupacional)
                        )}
                        ponderacion={item.resultadoCompetenciasComportamientosMap}
                      />
                      <Typography color="#003876">=</Typography>
                      <ProgressValueComponent value={Math.round(item.resultadoCompetenciasComportamientosMap + item.totalEvaluacion)} />
                    </>
                  )}
                </div>
              </div>

              <div className="col-1">
                <div className="text-center mt-3 mb-3">
                  <p className="card-text fw-bold text-14">Estado</p>
                  {item.estado !== 0 &&
                    estadoPeriodo.estado !== 1 &&
                    !supervisor &&
                    permisosState.ROLE_ADMIN_EVALUACIONES | permisosState.ROLE_ADMIN && (
                      <IconButton onClick={() => openEvaluation(item.evaluacionId)}>
                        <LockOpenTwoToneIcon sx={{ color: '#003876', mt: -1.5 }} />
                      </IconButton>
                    )}
                </div>
              </div>

              <div className="col-2">
                <div style={{ marginTop: '2pc' }} className="d-flex justify-content-center">
                  {item.estado === 0 && !supervisor && permisosState.ROLE_ADMIN_EVALUACIONES | permisosState.ROLE_ADMIN && (
                    <IconButton onClick={() => openModalEditar(item)}>
                      <ModeEditOutlineIcon sx={{ color: '#003876' }} />
                    </IconButton>
                  )}

                  {item.estado === 0 && !supervisor && permisosState.ROLE_ADMIN_EVALUACIONES | permisosState.ROLE_ADMIN && (
                    <IconButton onClick={() => deleteEvaluacion(item.evaluacionId)}>
                      <DeleteForeverIcon sx={{ color: '#C72924' }} />
                    </IconButton>
                  )}

                  {!supervisor && permisosState.ROLE_ADMIN_EVALUACIONES | permisosState.ROLE_ADMIN ? (
                    <>
                      <div style={{ marginTop: '22' }}>
                        <IconButton title="Reporte pdf" onClick={() => generateReportEvaluacion(item)}>
                          <TaskOutlinedIcon sx={{ color: '#005215' }} />
                        </IconButton>

                        {estadoPeriodo.ano >= 2024 && (
                          <IconButton onClick={() => openEvaluacionEmpleado(item.hash)} id="btn-ver-detalle-evaluacion">
                            <FaEye color="#003876" />
                          </IconButton>
                        )}
                      </div>
                    </>
                  ) : (
                    <IconButton onClick={() => openEvaluacionEmpleado(item.hash)}>
                      <ExitToAppRoundedIcon sx={{ color: '#003876' }} />
                    </IconButton>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <Typography mt={5} mb={5} align="center">
          No hay registros
        </Typography>
      )}

      <TablePagination
        component="div"
        count={listaEvaluacionesPorAnoCount}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      {/* MODALS */}
      <EvaluacionDetalleModal
        open={open}
        setOpen={setOpen}
        tipoAccion={tipoAccion}
        evaluado={evaluado}
        setEvaluado={setEvaluado}
        setEmpleado={setEmpleado}
        periodo={parseInt(ano)}
        refreshList={refreshList}
      />

      <EvaluacionNotificacionModal open={openN} setOpen={setOpenN} periodo={ano} isValidation={validationActionNotify} />

      <Loading open={isLoading} />
    </Encabezado>
  );
};
